import React from 'react';
import ContactForm from '../components/ContactForm';
import './Contact.css';

const Contact = () => {
    return (
        <div className="contact-page">
            <ContactForm />
        </div>
    );
};

export default Contact;
